<template>
  <div class="mb-4">
    <div id="map3" style="height: 150px"></div>
  </div>
</template>
<script setup>
import { onMounted, defineProps } from "vue";

let props = defineProps(["coordinates"]);

onMounted(() => {
  var lat = 35.243154;
  var lang = 60.624704;
  let coords = props.coordinates;
  const map = new nmp_mapboxgl.Map({
    mapType: "neshanRaster",
    container: "map3",
    zoom: 13,
    pitch: 0,
    center: [lang, lat],
    trackResize: true,
    interactive: false,
    touchZoomRotate: { around: "center" },
    scrollZoom: { around: "center" },
    mapKey: "web.0f8e46e0aba84f5fbdcf09ae6b11532d",
    poi: false,
    traffic: false,
    mapTypeControllerStatus: { show: false, position: "top-left" },
  });

  const supplierMarker = document.createElement("div");
  supplierMarker.className = "shop";
  new nmp_mapboxgl.Marker(supplierMarker)
    .setLngLat([coords.supplier[1], coords.supplier[0]])
    .addTo(map);

  const userMarker = document.createElement("div");
  userMarker.className = "destination";
  new nmp_mapboxgl.Marker(userMarker)
    .setLngLat([coords.user[1], coords.user[0]])
    .addTo(map);

  console.log([coords.supplier[1], coords.supplier[0]]);
  console.log([coords.user[1], coords.user[0]]);

  map.fitBounds([
    [coords.supplier[1], coords.supplier[0]],
    [coords.user[1], coords.user[0]],
  ]);
  var coordinates = [
    [coords.supplier[1], coords.supplier[0]],
    [coords.user[1], coords.user[0]],
  ];
  var bounds = coordinates.reduce((bounds, coord) => {
    return bounds.extend(coord);
  }, new nmp_mapboxgl.LngLatBounds(coordinates[0], coordinates[1]));
  map.fitBounds(bounds, {
    padding: 40,
  });
});
</script>
<style>
#map3 {
  width: 100%;
  height: 100%;
  background: #eee;
  z-index: 1;
  top: 0;
  right: 0;
}

.shop {
  background-image: url("https://safir.radap.ir/static/img/shop.png");
  background-size: cover;
  width: 32px;
  height: 40px;
  top: -20px;
  cursor: pointer;
}

.destination {
  background-image: url("https://safir.radap.ir/static/img/myLocation.png");
  background-size: cover;
  width: 32px;
  height: 40px;
  top: -20px;
  cursor: pointer;
}
</style>
